import { setAuthCookies } from '@/libs/auth-cookie';
import { closeWebView } from '@eastmoney/mku';
import browser from '@/libs/browser';
import store from '@/store';

/**
 * @description: app 原生登录交互
 * @param :
 * @return {*}
 * @param {string} callbackname
 */
export const onAppLogin = callbackname => {
    const json = {
        callbackname,
        textmsg: '',
        wechat: '1',
        qq: '1',
        sina: '1'
    };

    try {
        // ios
        if (browser.isIOS()) {
            window.location.href = `emH5NativeLogin:${JSON.stringify(json)}`;
        } else if (window.__EM != 'undefined' && window.__EM.prompt != 'undefined') {
            // Android
            window.__EM.prompt('emH5NativeLogin', JSON.stringify(json));
        } else {
            prompt('emH5NativeLogin', JSON.stringify(json));
        }
    } catch (error) {
        console.log(error);
    }
};

/**
 * @description: app 原生获取登录状态
 * @param :用户信息
 * @return {*}
 * @param {string} appinfo
 */
export const getLoginStatus = () => {
    const json = {
        callbackname: 'getAppInfo'
    };
    // ios
    if (browser.isIOS()) {
        window.location.href = `emH5GetLoginStatus:${JSON.stringify(json)}`;
    } else if (window.__EM != 'undefined' && window.__EM.prompt != 'undefined') {
        // Android
        window.__EM.prompt('emH5GetLoginStatus', JSON.stringify(json));
    } else {
        prompt('emH5GetLoginStatus', JSON.stringify(json));
    }
};

export function setTitle(title) {
    if (browser.isApp()) {
        if (browser.isIOS()) {
            window.location = `emH5Title:${JSON.stringify({
                title1: title
            })}`;
        } else if (window.__EM != 'undefined' && window.__EM.prompt != 'undefined') {
            window.__EM.prompt(
                'emH5Title',
                JSON.stringify({
                    title1: title
                })
            );
        } else {
            prompt(
                'emH5Title',
                JSON.stringify({
                    title1: title
                })
            );
        }
    } else {
        document.title = title;
    }
}

/**
 * @description:  app跳转外链
 * @param : 跳转类型
 * @return {*}
 * @param {string} type
 */
export function openApp(type) {
    let url = '';
    // app 内直接跳短链
    if (browser.isApp()) {
        if (browser.isAndroid()) {
            url = `dfcft://router/hybrid/react?id=${type}`;
        } else {
            url = `eastmoney://page/emrn?id=${type}`;
        }
    } else {
        // 浏览器上跳外链
        url = 'https://emh5wap.eastmoney.com/h52n/CommScheme?linktype=857&sharetype=1';
    }
    window.location.href = url;
}

/**
 * @description: 原生获取用户信息回调
 * @param :
 * @return {*}
 * @param {any} returnValue
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.getAppInfo = returnValue => {
    const res = JSON.parse(returnValue);
    if (res.data && res.data.ct && res.data.ut) {
        const { ct, ut } = res.data;
        setAuthCookies({ ct, ut });
        store.dispatch('getQuestionConfig', store.state.questionnaireCode);
    } else {
        window.restartQ = res => {
            if (JSON.parse(res).data) {
                const {
                    data: { ct, ut }
                } = JSON.parse(res);
                setAuthCookies({ ct, ut });
                store.dispatch('getQuestionConfig', store.state.questionnaireCode);
            } else {
                closeWebView();
            }
        };
        setTimeout(() => {
            onAppLogin('restartQ');
        }, 500);
    }

    // if (!returnValue || returnValue === undefined) {
    //     UserStoreModule.SET_TOKEN('');
    //     return;
    // }
    // const res = JSON.parse(returnValue);
    // // 原生登录
    // if (res.code == '0' && res.data) {
    //     const token = {
    //         CToken: res.data.ct,
    //         UToken: res.data.ut
    //     };
    //     const userInfo = {
    //         UAlias: decodeURIComponent(res.data.nickname),
    //         headPicUrl: `http://avator.eastmoney.com/qface/${res.data.uid}/120`
    //     };
    //     UserStoreModule.SET_USER_INFO(userInfo);
    //     UserStoreModule.SET_TOKEN(token);
    //     getUserBaseInfo();
    // } else {
    //     UserStoreModule.SET_TOKEN('');
    // }
};

/**
 * @description: 跳转到答题活动页
 * @param :
 * @return {*}
 * @param {*} async
 */
// export const routerToQuiz = async () => {
//     const { activityCode } = AppStoreModule.activityConfig;
//     await store.dispatch('startQuiz', activityCode);
//     const { quizId } = store.getters;
//     router.push(`/${activityCode}/quiz/${quizId}`);
// };

/**
 * @description:原生登录跳转到答题活动页
 * @param :
 * @return {*}
 * @param {string} returnValue
 */
// window.loginBackAward = returnValue => {
//     const res = JSON.parse(returnValue);
//     UserStoreModule.AppLoginBack(res);
//     if (res && res.code == '0') {
//         const { activityCode } = AppStoreModule.activityConfig;
//         router.push(`/${activityCode}/detail/reward`);
//     }
// };

/**
 * @description:原生登录跳转到答题活动页
 * @param :
 * @return {*}
 * @param {string} returnValue
 */
// window.loginBackQuiz = returnValue => {
//     const res = JSON.parse(returnValue);
//     UserStoreModule.AppLoginBack(res);
//     if (res && res.code == '0') {
//         routerToQuiz();
//     }
// };

/**
 * 设置在app中页面通顶方式
 */
export function setPageFullTopMode(mode = '1') {
    if (!browser.isApp()) {
        return;
    }
    try {
        const json = {
            type: 'setWebViewType',
            param: {
                action: mode //  2：顶通（仅限Android使用） 1： 普通 3: 透明（仅限iOS使用）
            }
        };
        if (browser.isAndroid()) {
            window.__EM.prompt('triggerPageAction', JSON.stringify(json)); // android
        } else {
            // window.location.href = `eastmoney.triggerPageAction(${JSON.stringify(json)})` //ios
            eastmoney.triggerPageAction(JSON.stringify(json));
        }
    } catch (error) {
        console.log(error);
    }
}
